
const OPEN_HOT_SPOT_MODAL = 'OPEN_HOT_SPOT_MODAL';
const CLOSE_HOT_SPOT_MODAL = 'CLOSE_HOT_SPOT_MODAL';
const CHANGE_HOT_SPOT_FIELD = 'CHANGE_HOT_SPOT_FIELD';


export const openHotSpotModal = ({
    selectedHotSpot,
}) => ({
    type: OPEN_HOT_SPOT_MODAL,
    selectedHotSpot,
});

export const closeHotSpotModal = () => ({
    type: CLOSE_HOT_SPOT_MODAL,
});

export const changeHotSpotField = (
    field, value,
) => ({
    type: CHANGE_HOT_SPOT_FIELD,
    field,
    value,
});

export const hotSpotModalInitialState = {
    selectedHotSpot: {
        categories: [],
        description: '',
        endDate: null,
        fieldsWithError: [],
        selectedCategories: [],
        startDate: new Date(),
        title: '',
    },
    isHotSpotModalOpen: false,
};

export const hotSpotModalReducer = (state = hotSpotModalInitialState, action) => {
    switch (action.type) {
    case OPEN_HOT_SPOT_MODAL:
        return {
            ...state,
            selectedHotSpot: {
                ...state.selectedHotSpot,
                ...action.selectedHotSpot,
            },
            isHotSpotModalOpen: true,
        };
    case CLOSE_HOT_SPOT_MODAL:
        return {
            ...state,
            ...hotSpotModalInitialState,
        };
    case CHANGE_HOT_SPOT_FIELD:
        return {
            ...state,
            selectedHotSpot: {
                ...state.selectedHotSpot,
                [action.field]: action.value,
            },
        };
    default:
        return state;
    }
};
